import React, { Component } from 'react';
import { bool, func, object } from 'prop-types';
import './CardLayover.scss';

CardLayover.propTypes = {
  children: object,
  display: bool,
  layoverContent: func
};

function CardLayover(props) {
  const { children, display, layoverContent } = props;

  return (
    <div className="layover__container">
      {display && layoverContent()}
      {children}
    </div>
  );
}

export default CardLayover;
